// ---
// Toggle Video Play and Pause
// ---
const heroModule = document.querySelectorAll('.hero-module');

heroModule.forEach((ele) => {
  const video = ele.querySelector('video');

  const restartVideo = (video, ele) => {
    setTimeout(() => {
      video.currentTime = 0; // Reset to the beginning
      video.play(); // Start the video
      ele.classList.remove('is-stopped');
    }, 300);
  };

  if (video) {
    setInterval(() => {
      if (video.duration === video.currentTime) {
        ele.classList.add('is-stopped');
      } else {
        if (windowWidth() > breakpointMd) {
          video.addEventListener('click', () => restartVideo(video, ele));
        } else {
          video.addEventListener('touchend', () => restartVideo(video, ele));
        }
      }
    }, 1000);
  }
});
